import {React,useState,useEffect }from "react";

import { Row, Col, Card, CardBody, CardTitle } from "reactstrap";
import { Link } from "react-router-dom";

import ApexRadial from "./ApexRadial";

const MonthlyEarning = () => {
    const [agent, setAgent] = useState('')
    const [agentCode, setAgentcode] = useState('')
    const [premium, setPremium] = useState(0)
    const [previous, setPrevious] = useState(0)
    const [agentName, setAgentname] = useState('')
      const [credentials, setCredentials] = useState(null)
      const [isAuth, setIsauth] = useState(false)
      const company = 'Definite'
    
      useEffect(()=>{
      const getCredentials =async()=>{
        const res = await fetch(`https://digitalapi.definiteassurance.com/api/getCredentials?username=${company}`)
        const data = await res.json();
        const {Username, Password} = data;
        const cred = btoa(`${Username}:${Password}`)
        setCredentials(btoa(`${Username}:${Password}`))
        setIsauth(true)
    
    
      }
      getCredentials()
    
      },[])


  
    useEffect(() => {
  
        const user = localStorage.getItem('definiteagent'); // Retrieve email
        if (user) {
            
            setAgent(user)
        } else {
    
        }
        }, []);
    
        useEffect(()=>{
            const getAgentcode =async()=>{
                const res =await fetch(`https://digitalapi.definiteassurance.com/api/getDealerdetails?email=${agent}`,{
                method:"GET",
                headers:{
                  'Authorization': `Basic ${credentials}`,
                  'Content-Type': "application/json"
                }
                });
                const data = await res.json();
                setAgentcode(data.OID)   
    
            }
  
            if(agent && isAuth){
             
                getAgentcode()
            }
        },[agent,isAuth])
  
        useEffect(()=>{
          const getData =async()=>{
            const res = await fetch(`https://digitalapi.definiteassurance.com/api/getMonthearned?agent=${agentCode}`,{
                method:"GET",
                headers:{
                  'Authorization': `Basic ${credentials}`,
                  'Content-Type': "application/json"
                }
            })
            const data = await res.json()
            if(data.TotalCommission == null){
              setPremium(0)
            }
            else{
              setPremium(data.TotalCommission)
            }
            
          }

          const getPrevious =async()=>{
            const res = await fetch(`https://digitalapi.definiteassurance.com/api/getPreviousMonthearned?agent=${agentCode}`,{
                method:"GET",
                headers:{
                  'Authorization': `Basic ${credentials}`,
                  'Content-Type': "application/json"
                }
            })
            const data = await res.json()
            if(data.TotalCommission == null){
              setPrevious(0)
            }
            else{
              setPrevious(data.TotalCommission)
            }
          }
  
          if(agentCode && isAuth){
            getData();
            getPrevious();
          }
  
        },[agentCode,isAuth])
  
        function formatter(amount) {
          return amount.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
          }
  return (
    <div>
      {" "}
      <Card>
        <CardBody>
          <CardTitle className="mb-4">Net Commission</CardTitle>
          <Row>
            <Col sm="6" style={{height:'150px'}}>
              <p className="text-muted">This month</p>
              <h3>KES. {formatter(parseInt(premium))}</h3>
              <h6 className="text-muted">
                Last Month
                <span className="text-success me-2">
                  {" "}
                 KES. {formatter(parseInt(previous))} {" "}
                </span>{" "}
                
              </h6>
              
            </Col>
            <Col sm="6">
              {/* <div className="mt-4 mt-sm-0">
                <ApexRadial dataColors='["--bs-primary"]' />
              </div> */}
            </Col>
          </Row>
          
        </CardBody>
      </Card>
    </div>
  );
};

export default MonthlyEarning;
